module.exports = __webpack_public_path__ + "img/hand-index-thumb-fill.6b9751ae.svg";